import http from './request'
// ----------------------佣金明细接口----------------------
// 有数据月份
export const getAssetDetailsMonth = (params) => {
  return http({
    url: '/user/auth/commission/monthList',
    method: 'get',
    params
  })
}
// 明细接口
export const queryAssetDetails = (data) => {
  return http({
    url: '/user/auth/commission/list',
    method: 'post',
    data
  })
}

// --------------------3.0.8新接口---------------------------------
// 获取faq
export const getFaqList = (params) => {
  return http({
    url: '/user/auth/withdraw/faq/listFaq',
    method: 'get',
    params
  })
}
// 提现配置接口
export const getWithdrawConfig = (params) => {
  return http({
    url: '/user/auth/withdraw/withdrawConfig',
    method: 'get',
    params
  })
}
// 查询taurus分享信息
export const getShareList = (params) => {
  return http({
    url: '/user/share/list',
    method: 'get',
    params
  })
}

// 用户当前是否可以提现接口
export const getWithdrawCheck = (params) => {
  return http({
    url: '/user/auth/withdraw/check',
    method: 'get',
    params
  })
}

// 查询银行卡信息列表
export const getBankCardList = (data) => {
  return http({
    url: '/user/auth/withdraw/bank/query',
    method: 'post',
    data
  })
}

// 查询提现记录
export const getAuthCardList = (data) => {
  return http({
    url: '/user/auth/withdraw/withdrawDetail',
    method: 'post',
    data
  })
}

// 校验短信验证码-是否本人操作账号信息
export const userAuthBankCheck = (data) => {
  return http({
    url: '/user/auth/withdraw/bank/check/user_self_operate',
    method: 'post',
    data
  })
}

// 添加银行卡信息
export const addWithDrawBank = (data) => {
  return http({
    url: '/user/auth/withdraw/bank/saveOrUpdate',
    method: 'post',
    data
  })
}
// 删除银行卡信息
export const deleteWithDrawBank = (data) => {
  return http({
    url: '/user/auth/withdraw/bank/delete',
    method: 'post',
    data
  })
}

// 发起提现接口
export const initiateWithdrawal = (data) => {
  return http({
    url: '/user/auth/withdraw/payout',
    method: 'post',
    data
  })
}

// 查询资产详情收入来源
export const searchAssetFrom = (data) => {
  return http({
    url: '/user/auth/commission/list',
    method: 'post',
    data
  })
}

// 查询指定用户有数据月份
export const searchCommisMonth = (data) => {
  return http({
    url: '/user/auth/commission/monthList?balanceType=2&type=0',
    method: 'post',
    data
  })
}
//   根据卡号查询卡密等信息
export const queryGiftCardByCardNum = (params) => {
  return http({
    url: '/user/auth/withdraw/getGiftCardInfo',
    method: 'get',
    params
  })
}
// 获取小喇叭信息接口
export const getNoticeInfo = (params) => {
  return http({
    url: '/user/auth/withdraw/getNotices',
    method: 'get',
    params
  })
}

// ----------------------提现二期优化-----------------------
// 提现反馈全局通知
export const getWithdrawFeedBackNotice = (data) => {
  return http({
    url: '/user/auth/withdraw/withdrawFeedBackNotice',
    method: 'post',
    data
  })
}
// 获取反馈列表
export const getFeedbackList = (data) => {
  return http({
    url: '/user/auth/withdraw/feedbackDetail',
    method: 'post',
    data
  })
}
//新增反馈
export const addFeedback = (data) => {
  return http({
    url: '/user/auth/withdraw/feedback/add',
    method: 'post',
    data
  })
}
//修改反馈
export const updateFeedback = (data) => {
  return http({
    url: '/user/auth/withdraw/feedback/update',
    method: 'post',
    data
  })
}
//获取abtest分组信息
export const getABtestDetail = (data) => {
  return http({
    url: '/user/auth/withdraw/abtestDetail',
    method: 'post',
    data
  })
}

// 发起提现
export const withdrawPayout = (data) => {
  return http({
    url: '/user/auth/withdraw/payout',
    method: 'post',
    data
  })
}

// 获取roi任务列表
export const payCenterGetTasks = (data) => {
  return http({
    url: '/payCenter/Task/getTasks',
    method: 'post',
    data
  })
}

// 领取任务奖励
export const reviewTask = (data) => {
  return http({
    url: '/user/ad/auth/review',
    method: 'post',
    data
  })
}
